import ApiService from "@/utils/request";
export const mmsApi = {
    // 视频流接口
    getCameras: () => ApiService.get("/mdata/device/cameras?siteCode=A-1"),
    // 获取链接接口
    getLinkAddress: () => ApiService.get("/mms/bigScreen/getLinkAddress"),
    // 实时库存
    getRealTimeInventory: () => ApiService.get("/mms/bigScreen/getRealTimeInventory"),
    // 出入库统计
    getInventoryStatistics: () => ApiService.get("/mms/bigScreen/getInventoryStatistics/3"),
    //货架运行状态
    getWhShelfStatus: () => ApiService.get("/wms/stat/shelf/usedTotal?warehouseId=1"),
    //货架运行状态
    getInventoryCategory: () => ApiService.get("/mms/bigScreen/getInventoryCategory"),
    getInfoBySlotCode: (slotCode) => ApiService.get(`/wms/stat/shelf/row/total?shelfRowCode=${slotCode}`),
};
